import { AGREEMENT_GROUP_FIELD } from 'constants/Constants';
import { updateObject } from 'store/utility';
import * as Types from 'components/TrustCenter/store/actions/types';
import { isEmptyList, isNotEmptyList } from 'components/Common/Utils/StringUtils';
import { SET_CLOSE_ALL_PANEL } from '../actions/types';

const initialState = {
    agreements: {},
    searchText: '',
    selectedVisibilityProvider: {},
    mobilityData: [],
    identifiers: new Map(),
    shipperCodes: [],
    enableOperation: false,
    dataSource: [],
    selectedDataSource: {},
    selectedProvider: {},
    selectedConnection: {},
    currentOperation: '', //move to trustcenter reducer
    disableOtherOperation: false, //move to trustcenter reducer
    showSpinner: false,
    newShipperAgreement: {}, //use only for new
    newAgreementGroup: AGREEMENT_GROUP_FIELD,
    existingAgreementGroup: {},
    isFromCreateFlow: false,
    showAgreementCreation: false,
    editedAgreements: {},
    filteredAgreements: {},
    deletedAgreements: [],
    groupToOpen: '',
    isAgreementInEditMode: {},
    agreementSaved: false,
    newConnectionId: '',
    discardChanges: false,
    groupNames: [],
    isShipperGroupLoaded: false,
    isShipperCodeLoaded: false,
    newTruckAgreements: [],
    newTruckRequest: [],
    disableConnectionSwitch: false,
    isProviderConnectionLoaded: false,
    isEmptyAgreements: false,
    closeAllPanel: false,
    trustCenterEvents: [],
    trustCenterEventsLoaded: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.GET_CONNECTION_AGREEMENTS:
            return updateObject(state, { agreements: action.payload });
        case Types.GET_MOBILITY_DATA:
            return updateObject(state, { mobilityData: action.payload });
        case Types.SET_NEW_TRUCK_AGREEMENT:
            let newTruckAgreements = [];
            newTruckAgreements.push(action.payload);

            return updateObject(state, {
                newTruckAgreements: [...newTruckAgreements]
            });
        case Types.UPDATE_TRUCK_AGREEMENT:
            let newEditedTruckAgreements = [];
            newEditedTruckAgreements.push(action.payload);

            return updateObject(state, {
                newTruckAgreements: [...newEditedTruckAgreements]
            });
        case Types.GET_GROUPNAMES:
        case Types.CLEAR_GROUPNAMES:
            return updateObject(state, { groupNames: action.payload });
        case Types.SET_PROVIDER:
            return updateObject(state, {
                selectedVisibilityProvider: action.payload
            });
        case Types.CLEAR_TRUCK_AGREEMENT:
            return updateObject(state, { newTruckAgreements: [] });
        case Types.GET_GROUP_AGREEMENTS:
            let agreementMap = { ...state.agreements };
            if (agreementMap.hasOwnProperty(action.payload[0].group_name)) {
                agreementMap[action.payload[0].group_name] = action.payload;
            } else {
                agreementMap = {};
                let groupList = Object.keys(state.agreements);
                groupList.push(action.payload[0].group_name);
                groupList = groupList.sort();
                groupList.forEach((group) => {
                    if (group !== action.payload[0].group_name) {
                        agreementMap[group] = JSON.parse(JSON.stringify(state.agreements[group]));
                    } else {
                        agreementMap[group] = action.payload;
                    }
                });
            }
            return updateObject(state, {
                agreements: { ...agreementMap }
            });
        case Types.REMOVE_GROUP:
            let agreementGroupMap = state.agreements;
            let groupList = Object.keys(agreementGroupMap);
            groupList.splice(groupList.indexOf(action.payload), 1);
            let newAgreementGroup = {};
            groupList.forEach((group) => {
                newAgreementGroup[group] = agreementGroupMap[group];
            });
            return updateObject(state, {
                agreements: { ...newAgreementGroup },
                isAgreementInEditMode: {}
            });
        case Types.ADD_NEW_TRUCK:
            let newTruckList = [...state.newTruckRequest];
            newTruckList.push(action.payload);
            return updateObject(state, {
                newTruckRequest: newTruckList
            });
        case Types.ADD_NEW_TRUCK_AGREEMENT:
            let truckList = [...state.newTruckAgreements];
            truckList = truckList.concat(action.payload);
            return updateObject(state, { newTruckAgreements: [...truckList] });
        case Types.REMOVE_TRUCK:
            const updatedTruckList = [...state.newTruckRequest];
            updatedTruckList.splice(action.payload, 1);
            return updateObject(state, {
                newTruckRequest: [...updatedTruckList]
            });
        case Types.UPDATE_TRUCK:
            return updateObject(state, {
                newTruckRequest: [...action.payload]
            });
        case Types.CLEAR_TRUCK:
            return updateObject(state, {
                newTruckRequest: []
            });
        case Types.RESET_AGREEMENTS:
            return updateObject(state, {
                agreements: {}
            });
        case Types.IS_EMPTY_AGREEMENTS:
            return updateObject(state, { isEmptyAgreements: action.payload });
        case Types.TOGGLE_SPINNER:
            return updateObject(state, {
                showSpinner: action.payload
            });
        case Types.SET_FROM_CREATE_FLOW:
            return updateObject(state, {
                isFromCreateFlow: action.payload
            });
        case Types.DISABLE_AGREEMENT_OPERATIONS:
            return { ...state, disableOtherOperation: true };
        case Types.ENABLE_AGREEMENT_OPERATIONS:
            return { ...state, disableOtherOperation: false };
        case Types.AGREEMENT_CURRENT_OPERATION:
            return { ...state, currentOperation: action.payload };
        case Types.ADD_NEW_SHIPMENT_AGREEMENT:
        case Types.UPDATE_NEW_SHIPMENT_AGREEMENT:
            return {
                ...state,
                newShipperAgreement: JSON.parse(JSON.stringify(action.payload))
            };
        case Types.UPDATE_NEW_TRUCK_AGREEMENT:
            return { ...state, newTruckAgreements: action.payload };
        case Types.UPDATE_NEW_AGREEMENT_GROUP:
            return { ...state, newAgreementGroup: { ...action.payload } };
        case Types.TOGGLE_SHOW_CREATE_CONNECTION:
            return { ...state, showAgreementCreation: action.payload };
        case Types.UPDATE_EDIT_EXISTING_SHIPMENT_AGREEMENT:
            return { ...state, editedAgreements: { ...action.payload } };
        case Types.UPDATE_SEARCH_TEXT:
            return updateObject(state, { searchText: action.payload });
        case Types.RESET_SEARCH_TEXT:
            return updateObject(state, { searchText: '' });
        case Types.UPDATE_FILTERED_AGREEMENTS:
            return { ...state, filteredAgreements: { ...action.payload } };
        case Types.UPDATE_DELETED_AGREEMENTS:
            return { ...state, deletedAgreements: [...action.payload] };
        case Types.CHECK_CLEAR_EDITED_AGREEMENTS:
            let editedAgreements = {};
            if (isNotEmptyList(state.editedAgreements[action.payload.groupName])) {
                editedAgreements = JSON.parse(JSON.stringify(state.editedAgreements));
                let deletedSet = new Set(action.payload.deletedAgreements);
                for (let i = 0; i < editedAgreements[action.payload.groupName].length; ) {
                    if (deletedSet.has(editedAgreements[action.payload.groupName][i].id)) {
                        editedAgreements[action.payload.groupName].splice(i, 1);
                    } else {
                        i++;
                    }
                }
            }
            return { ...state, deletedAgreements: [], editedAgreements: editedAgreements };
        case Types.OPEN_GROUP:
            return { ...state, groupToOpen: action.payload };
        case Types.UPDATE_EXISTING_AGREEMENT_GROUP:
            let payload = action.payload;
            if (Object.keys(action.payload).length > 0) {
                if (Object.keys(action.payload[Object.keys(action.payload)[0]]).length > 0) {
                    if (
                        isEmptyList(action.payload[Object.keys(action.payload)[0]])
                            .shipment_identifier
                    ) {
                        payload = {};
                    }
                }
            }
            return { ...state, existingAgreementGroup: { ...payload } };
        case Types.TOGGLE_AGREEMENT_EDIT_MODE:
            return { ...state, isAgreementInEditMode: { ...action.payload } };
        case Types.DISCARD_CHANGES:
            return { ...state, discardChanges: action.payload };
        case Types.GET_SHIPPER_CODES:
            return updateObject(state, { shipperCodes: action.payload });
        case Types.SET_DATASOURCE:
            return updateObject(state, { dataSource: action.payload });
        case Types.GET_SHIPPER_IDENTIFIERS:
            let existingIdentifiers = state.identifiers;
            existingIdentifiers.set(action.payload.datasourceId, action.payload.identifiers);
            return updateObject(state, { identifiers: new Map(existingIdentifiers) });
        case Types.CHANGE_CONNECTIONS:
            return updateObject(state, { selectedConnection: action.payload });
        case Types.SHIPPER_CODES_LOADED:
            return { ...state, isShipperCodeLoaded: action.payload };
        case Types.SHIPPER_GROUP_LOADED:
            return updateObject(state, { isShipperGroupLoaded: action.payload });
        case Types.GET_SELECTED_PROVIDER_DETAILS:
            return { ...state, selectedProvider: { ...action.payload } };
        case Types.GET_SELECTED_DATA_SOURCE:
            return { ...state, selectedDataSource: { ...action.payload } };
        case Types.AGREEMENT_SAVE_FLAG:
            return { ...state, agreementSaved: action.payload };
        case Types.STORE_NEW_CONNECTION_ID:
            return { ...state, newConnectionId: action.payload };
        case Types.ENABLE_GETCONNECTION_OPERATIONS:
            return { ...state, enableOperation: true };
        case Types.DISABLE_GETCONNECTION_OPERATIONS:
            return { ...state, enableOperation: false };
        case Types.DISABLE_CONNECTION_STATUS_OPERATIONS:
            return { ...state, disableConnectionSwitch: true };
        case Types.ENABLE_CONNECTION_STATUS_OPERATIONS:
            return { ...state, disableConnectionSwitch: false };
        case Types.TOGGLE_PROVIDER_CONNECTION_LOADED:
            return { ...state, isProviderConnectionLoaded: action.payload };
        case SET_CLOSE_ALL_PANEL:
            return updateObject(state, { closeAllPanel: action.payload });
        case Types.GET_TRUSTCENTER_EVENT_TYPES:
            return { ...state, trustCenterEvents: action.payload };
        case Types.TOGGLE_EVENTS_LOADED:
            return { ...state, trustCenterEventsLoaded: action.payload };
        default:
            return state;
    }
};
